import { useQuery } from "@tanstack/react-query";
import {
  type IBookletRequest,
  type IJointBillServiceEditData,
  type IJointBillServicePeriodList,
} from "@services/jointBillServices/types";
import { type IOverviewJointBillService } from "@services/overview/types";
import { queryClient } from "@/queryClient";
import {
  getBillBooklets,
  getJBSEditData,
  getJBSPeriodList,
  getProviderBillDetailizationHtml,
} from "./services";

export const useJointBillServicePeriodListQuery = () =>
  useQuery<IJointBillServicePeriodList[]>({
    queryKey: ["jointBillServicePeriodList"],
    queryFn: () => getJBSPeriodList(),
    staleTime: Infinity,
  });

export const useJointBillServiceEditDataQuery = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  useQuery<IJointBillServiceEditData>({
    queryKey: ["jointBillServiceEditData", jointBillServiceId],
    queryFn: () => getJBSEditData(jointBillServiceId),
  });

export const prefetchJointBillServiceEditDataQuery = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  queryClient.prefetchQuery({
    queryKey: ["jointBillServiceEditData", jointBillServiceId],
    queryFn: () => getJBSEditData(jointBillServiceId),
  });

export const useProviderBillDetailizationQuery = (
  billId: number,
  billDetailizationUrl: string,
) =>
  useQuery({
    queryKey: ["providerBillDetailization", billId],
    queryFn: () =>
      getProviderBillDetailizationHtml({
        billDetailizationUrl: billDetailizationUrl,
      }),
  });

export const useBillBookletsQuery = (data: IBookletRequest) =>
  useQuery({
    queryKey: ["booklets", data.url],
    queryFn: () => getBillBooklets(data),
  });
